import React, { Suspense, lazy, useState } from "react";

import CustomReportCodeEditor from "~/modules/amc/customReports/customReportCodeEditor";
import { Grid } from "@material-ui/core";
import LoadingIndicator from "~/components/loadingIndicator/loadingIndicator";
import PageBlock from "~/components/containers/sideNavPageBlock";
import { get } from "lodash";
import { useTypedSelector } from "~/hooks/useTypedSelector";

const AMCChat = lazy(() => import("~/modules/amc/chat/amcChat"));

export interface ValidationResult {
  status: "success" | "error" | null;
  errorMessage: string | null;
}

// TO_DO: remove this default code
const DEFAULT_CODE = `SELECT
  campaign,
  SUM(impressions) AS impressions,
  SUM(clicks) AS clicks
FROM
  amazon_attributed_events_by_traffic_time
GROUP BY
  campaign`;

const CustomAmcReport = () => {
  const store = useTypedSelector((state) =>
    get(state, "persistentAppSettings.setting.data.currentStore")
  );
  const user = useTypedSelector((state) => state.user);
  const amcAiChatOn = user?.amcAiChatOn;
  const [initialCode, setInitialCode] = useState(DEFAULT_CODE);
  const [validationResult, setValidationResult] = useState<ValidationResult>({
    status: null,
    errorMessage: null,
  });

  if (!store) {
    return (
      <PageBlock>
        <LoadingIndicator />
      </PageBlock>
    );
  }

  return (
    <PageBlock>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {amcAiChatOn && (
            <Suspense fallback={<LoadingIndicator />}>
              <AMCChat
                setCode={setInitialCode}
                validationResult={validationResult}
                setValidationResult={setValidationResult}
              />
            </Suspense>
          )}
        </Grid>
        <Grid item xs={12} md={amcAiChatOn ? 6 : 12}>
          <CustomReportCodeEditor
            mid={store.merchantId}
            initialCode={initialCode}
            validationResult={validationResult}
            setValidationResult={setValidationResult}
          />
        </Grid>
      </Grid>
    </PageBlock>
  );
};

export default CustomAmcReport;
